const LubeServSite = {
  LubeServAnabuImusCavite: "lubeserv-anabu-imus-cavite",
  LubeServTelabastaganPampanga: "lubeserv-telabastagan-pampanga",
};

export default LubeServSite;
